import {
  Text,
  View,
  ScrollView,
  TouchableOpacity,
  Image,
  TextInput,
  ActivityIndicator,
} from "react-native";
import React, { useState, useEffect } from "react";
import { useRouter, useLocalSearchParams } from "expo-router";
import Icon from "react-native-vector-icons/FontAwesome";
import { useSelector, useDispatch } from "react-redux";
import { getAllLocation } from "../redux/actions/masteractions";
import FooterComponent from "../component/footer";
import { useLanguage } from "./LanguageProvider";

export default function LocationScreen() {
  const router = useRouter();
  const dispatch = useDispatch();
  const [selectedLocation, setSelectedLocation] = useState<
    "center" | "machine"
  >("center");
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true); // ✅ เพิ่ม state สำหรับ loading
  const { t } = useLanguage();

  useEffect(() => {
    setIsLoading(true); // ✅ เริ่มโหลด
    dispatch(getAllLocation() as any).finally(() => {
      setIsLoading(false); // ✅ หยุดโหลดหลังจากดึงข้อมูลเสร็จ
    });
  }, []);

  const {
    item: itemParams,
    scale: itemParamscale,
    item2: itemParam2,
  } = useLocalSearchParams();

  const item3 =
    typeof itemParams === "string" ? JSON.parse(itemParams) : itemParams;

  const scale =
    typeof itemParamscale === "string"
      ? JSON.parse(itemParamscale)
      : itemParamscale;

  const item2 =
    typeof itemParam2 === "string" ? JSON.parse(itemParam2) : itemParam2;

  const location = useSelector((state: any) => state?.master?.location) || null;

  // console.log("scale", JSON.stringify(scale, null, 2));
  // console.log("location =>", location);

  useEffect(() => {
    dispatch(getAllLocation() as any);
  }, []);

  // console.log("selectedLocation", selectedLocation);

  const filteredData = location
    .filter((item: any) => item.type === selectedLocation)
    .filter(
      (item: any) =>
        item.desc_location.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (item.type === "center"
          ? item.storage_location
              .toLowerCase()
              .includes(searchQuery.toLowerCase())
          : item.storage_location.toLowerCase().includes(searchQuery.toLowerCase()))
    );

  // console.log("filteredData", filteredData);

  // ✨ ไฮไลท์คำที่ค้นหา
  const highlightText = (text: string, keyword: string) => {
    if (!keyword) return text;

    const parts = text.split(new RegExp(`(${keyword})`, "gi")); // แยกคำค้นหาออกมา
    return (
      <>
        {parts.map((part, index) => (
          <Text
            key={index}
            style={{
              fontFamily: "Kanit",
              color:
                part.toLowerCase() === keyword.toLowerCase()
                  ? "red"
                  : "text-gray-500",
            }}
          >
            {part}
          </Text>
        ))}
      </>
    );
  };

  return (
    <View className="flex-1 bg-[#F17736] items-center justify-center">
      <View className="w-full h-[20%] bg-[#F17736] rounded-b-[50px]" />
      <View className="bottom-0 w-full h-[90%] bg-white rounded-t-[20px]" />

      <FooterComponent />

      <ScrollView
        contentContainerStyle={{ flexGrow: 1, padding: 20 }}
        showsVerticalScrollIndicator={false}
        className="absolute mt-2 top-0 w-[90%] h-[95%] px-2 bg-white rounded-2xl border border-gray-200 shadow-md"
      >
        <View className="w-full items-center justify-center border-b border-gray-300 pb-1">
          <Text className="text-2xl font-kanit py-2">
            {t("select_storage_location")}
          </Text>
        </View>

        <View className="w-full flex-1 pt-2">
          <View className="flex flex-row w-full items-center justify-around py-2">
            <TextInput
              // placeholder="ค้นหาสถานที่จัดเก็บ"
              placeholder={t("search_storage_location")}
              value={searchQuery}
              onChangeText={setSearchQuery}
              className="w-[100%] h-12 border border-gray-300 rounded-lg px-4 py-2 bg-gray-50 font-kanit"
            />
          </View>

          <View className="flex flex-row items-center justify-between py-2">
            <TouchableOpacity
              onPress={() => setSelectedLocation("center")}
              className={`rounded-lg w-[48%] px-4 py-3 flex-row items-center justify-center shadow-md ${
                selectedLocation === "center" ? "bg-blue-500" : "bg-gray-100"
              }`}
            >
              <Icon
                name="building"
                size={18}
                color={selectedLocation === "center" ? "#fff" : "#1688fa"}
              />
              <Text
                className={`text-lg font-kanit pl-2 ${
                  selectedLocation === "center" ? "text-white" : "text-blue-500"
                }`}
              >
                {/* Location Center */}
                {t("location_center")}
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => setSelectedLocation("machine")}
              className={`rounded-lg w-[48%] px-4 py-3 flex-row items-center justify-center shadow-md ${
                selectedLocation === "machine" ? "bg-blue-500" : "bg-gray-100"
              }`}
            >
              <Icon
                name="cogs"
                size={18}
                color={selectedLocation === "machine" ? "#fff" : "#1688fa"}
              />
              <Text
                className={`text-lg font-kanit pl-2 ${
                  selectedLocation === "machine"
                    ? "text-white"
                    : "text-blue-500"
                }`}
              >
                {/* Location Machine */}
                {t("location_machine")}
              </Text>
            </TouchableOpacity>
          </View>

          {isLoading ? (
            <View className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center">
              <ActivityIndicator size="large" color="#F17736" />
              <Text className="text-black text-lg font-kanit mt-4">
                {/* กำลังโหลดข้อมูล... */}
                {t("loading_data")}
              </Text>
            </View>
          ) : (
            <View className="w-full items-start justify-start py-2">
              {filteredData.map((item: any, index: any) => (
                <View
                  key={index}
                  className="w-full flex-row items-center justify-between py-2 rounded-xl bg-gray-100 px-4 mb-3"
                >
                  <View className="flex flex-row items-center justify-center py-1">
                    {item.type === "center" ? (
                      <Image
                        source={require("../../assets/fac_4.png")}
                        className="w-14 h-14 rounded-full"
                      />
                    ) : (
                      <Image
                        source={require("../../assets/coffee.png")}
                        className="w-14 h-14 rounded-full"
                      />
                    )}
                    <View className="flex flex-col items-start justify-center ml-3">
                      <Text className="text-xl font-kanit pl-1">
                        {highlightText(item.desc_location, searchQuery)}
                      </Text>
                      <View className="flex flex-row items-center justify-start">
                        <Icon name="map-marker" size={18} color="#58d68d" />
                        <Text className="text-md font-kanit text-gray-500 pl-1">
                          {highlightText(
                            item.type === "center"
                              ? item.storage_location
                              : item.storage_location,
                            searchQuery
                          )}
                        </Text>
                      </View>
                    </View>
                  </View>

                  <View className="flex flex-row items-center justify-center">
                    <TouchableOpacity
                      onPress={() =>
                        router.push({
                          pathname: "/screens/detaillocation",
                          params: {
                            item: JSON.stringify(item),
                            item2: JSON.stringify(item2),
                            scale: JSON.stringify(scale),
                            data: JSON.stringify(item3),
                          },
                        })
                      }
                      className="rounded-full bg-[#58d68d] py-2.5 px-4 items-center shadow-sm justify-center"
                    >
                      <Text className="text-white text-sm font-kanit pt-1">
                        {/* รายละเอียด */}
                        {t("detail")}
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              ))}
            </View>
          )}
        </View>
      </ScrollView>
    </View>
  );
}
